/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SafeDepositBoxSafeRoleOption
 */
export interface SafeDepositBoxSafeRoleOption {
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxSafeRoleOption
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxSafeRoleOption
     */
    label: string;
}

/**
 * Check if a given object implements the SafeDepositBoxSafeRoleOption interface.
 */
export function instanceOfSafeDepositBoxSafeRoleOption(value: object): value is SafeDepositBoxSafeRoleOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SafeDepositBoxSafeRoleOptionFromJSON(json: any): SafeDepositBoxSafeRoleOption {
    return SafeDepositBoxSafeRoleOptionFromJSONTyped(json, false);
}

export function SafeDepositBoxSafeRoleOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxSafeRoleOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function SafeDepositBoxSafeRoleOptionToJSON(json: any): SafeDepositBoxSafeRoleOption {
    return SafeDepositBoxSafeRoleOptionToJSONTyped(json, false);
}

export function SafeDepositBoxSafeRoleOptionToJSONTyped(value?: SafeDepositBoxSafeRoleOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
    };
}

